import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { TranslationModule } from '@fino-ui/translation';
import type { DnsCheck, KWSConfigLinks } from '../../kws.model';

@Component({
  selector: 'app-basic-info',
  templateUrl: './basic-info.component.html',
  styleUrl: './basic-info.component.sass',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslationModule],
})
export class BasicInfoComponent {
  links = input.required<KWSConfigLinks>();
  hasNachlass = input(false, { transform: booleanAttribute });
  dns = input<DnsCheck>();
  // the atruvia specific hint must never be shown to other banks
  isAtruvia = input(false, { transform: booleanAttribute });

  // OK and UNKNOWN (we could not tell) show nothing
  protected dnsMissing = computed(() =>
    ['ELSEWHERE', 'UNRESOLVED'].includes(this.dns()?.status),
  );

  // seems strange but bank employees often enter kws via control panel after entering business mode
  // they are confused while business mode is still active, so we have a dedicated route to reset kws to customer default mode
  protected testingHref = computed(() => {
    const t = this.links().testing;
    return `${t}${t.endsWith('/') ? '' : '/'}customer`;
  });

  protected anonymizedTestingHref = computed(() => {
    const t = this.links().anonymizedTesting;
    return `${t}${t.endsWith('/') ? '' : '/'}customer`;
  });

  protected productionHref = computed(() => {
    const p = this.links().production;
    return `${p}${p.endsWith('/') ? '' : '/'}customer`;
  });

  protected testingBusinessHref = computed(() => {
    const t = this.links().testing;
    return `${t}${t.endsWith('/') ? '' : '/'}business`;
  });

  protected anonymizedTestingBusinessHref = computed(() => {
    const t = this.links().anonymizedTesting;
    return `${t}${t.endsWith('/') ? '' : '/'}business`;
  });

  protected productionBusinessHref = computed(() => {
    const p = this.links().production;
    return `${p}${p.endsWith('/') ? '' : '/'}business`;
  });

  protected testingEstateHref = computed(() => {
    const t = this.links().testing;
    return `${t}${t.endsWith('/') ? '' : '/'}nachlass`;
  });

  protected anonymizedTestingEstateHref = computed(() => {
    const t = this.links().anonymizedTesting;
    return `${t}${t.endsWith('/') ? '' : '/'}nachlass`;
  });

  protected productionEstateHref = computed(() => {
    const p = this.links().production;
    return `${p}${p.endsWith('/') ? '' : '/'}nachlass`;
  });
}
